import { BookingCompressed } from '@jooxter/api';
import { useResourceTypeRepository } from '@jooxter/resource-types';
import { IFloorPlanBooking } from '@jooxter/floor-plan';
import { useCallback } from 'react';

const DEFAULT_MAP_ICON_SIZE = 1;

export const useBookingCompressedToIFloorPlanBookingConverter = (bookingsCompressed: BookingCompressed[] = []) => {
  const { repository } = useResourceTypeRepository();

  const convert = useCallback((): IFloorPlanBooking[] => {
    if (!repository) {
      return [];
    }

    return bookingsCompressed.map((bc: BookingCompressed) => ({
      ...bc,
      resource: {
        id: bc.resource.id,
        resourceType: repository.findById(bc.resource.resourceTypeId) ?? {
          mapIconSize: DEFAULT_MAP_ICON_SIZE,
        },
        state: bc.resource.state,
      },
    }));
  }, [repository, bookingsCompressed]);

  return { convert };
};
